"use strict";

{
    window.addEventListener('load', () => {
        const saveButtonNodes = document.querySelectorAll('.tteSaveButton');
        saveButtonNodes.forEach(saveButtonNode => {
            saveButtonNode.addEventListener('click', saveButtonClicked);
        });
    });

    
    function saveButtonClicked() {
        let saveData = {};

        saveData['overall'] = getOverallSettings();
        saveData['squareSlideInFromLeft'] = getSquareSlideInFromLeftSettings();
        saveData['popOut'] = getPopOutSettings();
        saveData['lineSwipe'] = getLineSwipeSettings();
        saveData['gateMark'] = getGateMarkSettings();
        saveData['borderRoundTrail'] = getBorderRoundTrailSettings();
        saveData['borderSplitTrailT2B'] = getBorderSplitTrailT2BSettings();
        saveData['borderSplitTrailB2T'] = getBorderSplitTrailB2TSettings();
        saveData['borderSplitTrailL2R'] = getBorderSplitTrailL2RSettings();
        saveData['borderSplitTrailR2L'] = getBorderSplitTrailR2LSettings();
        saveData['lineCurtain'] = getLineCurtainSettings();
        saveData['halfBackgroundRotate'] = getHalfBackgroundRotateSettings();
        saveData['doubleLineSlideIn'] = getDoubleLineSlideInSettings();
        saveData['accentUnderlineGrow1'] = getAccentUnderlineGrow1Settings();
        saveData['accentUnderlineGrow2'] = getAccentUnderlineGrow2Settings();
        saveData['accentUnderlineGrow3'] = getAccentUnderlineGrow3Settings();
        saveData['accentUnderlineGrow4'] = getAccentUnderlineGrow4Settings();
        saveData['accentUnderlineGrow5'] = getAccentUnderlineGrow5Settings();
        saveData['accentUnderlineGrow6'] = getAccentUnderlineGrow6Settings();
        saveData['accentUnderlineGrow7'] = getAccentUnderlineGrow7Settings();
        saveData['accentUnderlineGrow8'] = getAccentUnderlineGrow8Settings();

        fetchSaveData(saveData);
    }

    function getOverallSettings() {
        const overallDefaultColor = document.querySelector('.overallSettings .defaultColor');
        let rtn = {};
        
        rtn['defaultColor'] = overallDefaultColor.value;

        return rtn;
    }

    function getSquareSlideInFromLeftSettings() {
        const SquareSlideInFromLeftRectangleColor = document.querySelector('.tteSettingsContents-squareSlideInFromLeft .squareColor');
        let rtn = {};

        rtn['rectangleColor'] = SquareSlideInFromLeftRectangleColor.value;

        return rtn;
    }

    function getPopOutSettings() {
        const PopOutShadowColor = document.querySelector('.tteSettingsContents-PopOut .shadowColor');
        let rtn = {};

        rtn['shadowColor'] = PopOutShadowColor.value;

        return rtn;
    }

    function getLineSwipeSettings() {
        const lineSwipeBorderColor = document.querySelector('.tteSettingsContents-lineSwipe .lineSwipeBorderColor');
        let rtn = {};

        rtn['borderColor'] = lineSwipeBorderColor.value;

        return rtn;
    }

    function getGateMarkSettings() {
        const GateMarkGateColor = document.querySelector('.tteSettingsContents-gateMark .gateMarkGateColor');
        let rtn = {};

        rtn['gateColor'] = GateMarkGateColor.value;

        return rtn;
    }

    function getBorderRoundTrailSettings() {
        const BorderRoundTrailBorderColor = document.querySelector('.tteSettingsContents-borderRoundTrail .borderRoundTrailBorderColor');
        let rtn = {};

        rtn['borderColor'] = BorderRoundTrailBorderColor.value;

        return rtn;
    }

    function getBorderSplitTrailT2BSettings() {
        const BorderSplitTrailT2BBorderColor = document.querySelector('.tteSettingsContents-borderSplitTrailT2B .borderSplitTrailT2BBorderColor');
        let rtn = {};

        rtn['borderColor'] = BorderSplitTrailT2BBorderColor.value;

        return rtn;
    }

    function getBorderSplitTrailB2TSettings() {
        const BorderSplitTrailB2TBorderColor = document.querySelector('.tteSettingsContents-borderSplitTrailB2T .borderSplitTrailB2TBorderColor');
        let rtn = {};

        rtn['borderColor'] = BorderSplitTrailB2TBorderColor.value;

        return rtn;
    }

    function getBorderSplitTrailL2RSettings() {
        const BorderSplitTrailL2RBorderColor = document.querySelector('.tteSettingsContents-borderSplitTrailL2R .borderSplitTrailL2RBorderColor');
        let rtn = {};

        rtn['borderColor'] = BorderSplitTrailL2RBorderColor.value;

        return rtn;
    }

    function getBorderSplitTrailR2LSettings() {
        const BorderSplitTrailR2LBorderColor = document.querySelector('.tteSettingsContents-borderSplitTrailR2L .borderSplitTrailR2LBorderColor');
        let rtn = {};

        rtn['borderColor'] = BorderSplitTrailR2LBorderColor.value;

        return rtn;
    }

    function getLineCurtainSettings() {
        const LineCurtainLineColor = document.querySelector('.tteSettingsContents-lineCurtain .lineCurtainLineColor');
        let rtn = {};

        rtn['lineColor'] = LineCurtainLineColor.value;

        return rtn;
    }

    function getHalfBackgroundRotateSettings() {
        const halfBackgroundRotateBackgroundColor = document.querySelector('.tteSettingsContents-halfBackgroundRotate .halfBackgroundRotateBackgroundColor');
        let rtn = {};

        rtn['backgroundColor'] = halfBackgroundRotateBackgroundColor.value;

        return rtn;
    }

    function getDoubleLineSlideInSettings() {
        const doubleLineSlideInLineColor = document.querySelector('.tteSettingsContents-doubleLineSlideIn .doubleLineSlideInLineColor');
        let rtn = {};

        rtn['underlineColor'] = doubleLineSlideInLineColor.value;

        return rtn;
    }

    function getAccentUnderlineGrow1Settings() {
        const accentUnderlineGrow1UnderlineColor = document.querySelector('.tteSettingsContents-accentUnderlineGrow1 .underlineColor');
        let rtn = {};

        rtn['underlineColor'] = accentUnderlineGrow1UnderlineColor.value;

        return rtn;
    }

    function getAccentUnderlineGrow2Settings() {
        const accentUnderlineGrow1Under2ineColor = document.querySelector('.tteSettingsContents-accentUnderlineGrow2 .underlineColor');
        let rtn = {};

        rtn['underlineColor'] = accentUnderlineGrow1Under2ineColor.value;

        return rtn;
    }

    function getAccentUnderlineGrow3Settings() {
        const accentUnderlineGrow1UnderlineColor3 = document.querySelector('.tteSettingsContents-accentUnderlineGrow3 .underlineColor');
        let rtn = {};

        rtn['underlineColor'] = accentUnderlineGrow1UnderlineColor3.value;

        return rtn;
    }

    function getAccentUnderlineGrow4Settings() {
        const accentUnderlineGrow1UnderlineColor4 = document.querySelector('.tteSettingsContents-accentUnderlineGrow4 .underlineColor');
        let rtn = {};

        rtn['underlineColor'] = accentUnderlineGrow1UnderlineColor4.value;

        return rtn;
    }

    function getAccentUnderlineGrow5Settings() {
        const accentUnderlineGrow1UnderlineColor5 = document.querySelector('.tteSettingsContents-accentUnderlineGrow5 .underlineColor');
        let rtn = {};

        rtn['underlineColor'] = accentUnderlineGrow1UnderlineColor5.value;

        return rtn;
    }

    function getAccentUnderlineGrow6Settings() {
        const accentUnderlineGrow1UnderlineColor6 = document.querySelector('.tteSettingsContents-accentUnderlineGrow6 .underlineColor');
        let rtn = {};

        rtn['underlineColor'] = accentUnderlineGrow1UnderlineColor6.value;

        return rtn;
    }

    function getAccentUnderlineGrow7Settings() {
        const accentUnderlineGrow7UnderlineColor6 = document.querySelector('.tteSettingsContents-accentUnderlineGrow7 .underlineColor');
        let rtn = {};

        rtn['underlineColor'] = accentUnderlineGrow7UnderlineColor6.value;

        return rtn;
    }

    function getAccentUnderlineGrow8Settings() {
        const accentUnderlineGrow8UnderlineColor6 = document.querySelector('.tteSettingsContents-accentUnderlineGrow8 .underlineColor');
        let rtn = {};

        rtn['underlineColor'] = accentUnderlineGrow8UnderlineColor6.value;

        return rtn;
    }

    function fetchSaveData(saveData) {
        wp.apiFetch({
            path: 'tantive-text-effects/v1/save-settings',
            method: 'POST',
            body: JSON.stringify(saveData),
        })
        .then((response) => {
            alert(response['message']);
        })
        .catch((error) => {
            console.error('Error fetching settings:', error);
        });
    }
}